
import React from 'react'
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { changedColumns } from '../../../../redux/actions/index';
import { useParams } from 'react-router-dom';



export default function useEchoUpdateTicket() {
    const dispatch = useDispatch();
    const { id: ticketId } = useParams();

    useEffect(() => {
        if (!ticketId) return undefined;

        window.Echo.channel('ticket.' + ticketId).listen('.TicketUpdated', (e) => {
            let b = e?.changedColumns?.reduce((acc, key) => {
                acc[key] = new Date().getTime();
                return acc;
            }, {});
            dispatch(changedColumns(b,e.changedBy));
        });
        return () => {
            window.Echo.leave('ticket.' + ticketId);
        }
    }, [ticketId, dispatch]);
}
